import { store } from './index'
import { defineStore } from 'pinia'

import { useCache } from '@/hooks/useCache'

/* Npm Plugins - Element-plus Locale Map */
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import zhTw from 'element-plus/es/locale/lang/zh-tw'
import en from 'element-plus/es/locale/lang/en'
import vi from 'element-plus/es/locale/lang/vi'
import th from 'element-plus/es/locale/lang/th'

const { wsCache } = useCache()

const elLocaleMap = {
    'zh-cn': zhCn,          // 简体中文
    'zh-tw': zhTw,          // 繁体中文
    'en': en,               // 英语(美国)
    'vi': vi,               // 越南语
    'th': th                // 泰语
}

interface LocaleState {
    currentLocale: LocaleDropdownType
    localeMap: LocaleDropdownType[]
}

/* 多语言配置 */
export const useLocaleStore = defineStore('locales', {
    state: (): LocaleState => {
        return {
            currentLocale: {

                lang: wsCache.get('lang') || 'zh-cn',

                elLocale: elLocaleMap[wsCache.get('lang') || 'zh-cn']

            },
            localeMap: [
                { lang: 'zh-cn', name: '简体中文' },
                { lang: 'zh-tw', name: '繁体中文' },
                { lang: 'en', name: 'English' },
                { lang: 'vi', name: 'Tiếng Việt' },
                { lang: 'th', name: 'ภาษาไทย' },
            ]
        }
    },
    getters: {
        getCurrentLocale(): LocaleDropdownType {

            return this.currentLocale

        },
        getLocaleMap(): LocaleDropdownType[] {

            return this.localeMap

        }
    },
    actions: {
        setCurrentLocale(localeMap: LocaleDropdownType) {

            this.currentLocale.lang = localeMap?.lang

            this.currentLocale.elLocale = elLocaleMap[localeMap?.lang]

            wsCache.set('lang', localeMap?.lang)
        }
    }
})

export const useLocaleStoreWithOut = () => {

    return useLocaleStore(store)

}
